import * as React from "react";

function SvgStatePending(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M8.553 7.549V2.92a.374.374 0 00-.374-.373H7.027a.373.373 0 00-.373.373v6.228a.373.373 0 00.373.374h4.511a.373.373 0 00.373-.374V8a.373.373 0 00-.373-.374H8.627a.074.074 0 01-.074-.077zM8 16a8 8 0 118-8 8 8 0 01-8 8z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgStatePending);
export default ForwardRef;